/**
 * Обращение в поддержку из любого раздела (ПОРТ-61 → БО-60). Контекст экрана — только
 * технические данные (раздел, адрес страницы, клиника, язык, версия, браузер, код запроса) —
 * без персональных и медицинских данных. Эндпоинт — Q-WEB-03; пока сервер его не отдаёт (404),
 * «Помощь» говорит об этом прямо и сохраняет текст обращения. Запрос — через типизированный клиент (TD-27).
 */
import type { DodocClient } from '@dodoc/api-client';
import { call } from './http';

export type SupportTopic = 'question' | 'problem' | 'idea';

export interface SupportContext {
  sectionId: string | null;
  path: string;
  clinicId: string | null;
  locale: string;
  appVersion: string;
  userAgent: string;
  viewport: string;
  requestId: string | null;
  errorCode: string | null;
}

/** Экран, с которого пишут: путь без query/hash и название раздела на языке пользователя. */
export interface SupportScreen {
  route: string;
  title: string;
}

/** Контракт POST /api/v1/support/tickets: { subject, message, screen: { route, title }, context? } → { id, number }. */
export interface SupportTicketInput {
  subject: string;
  message: string;
  screen: SupportScreen;
  context?: SupportContext;
  topic?: SupportTopic;
}

export interface SupportTicket {
  id: string;
  number: string;
}

export function createSupportApi(api: DodocClient) {
  return {
    createTicket: async (input: SupportTicketInput): Promise<SupportTicket> =>
      // context в OpenAPI — свободный объект; копия интерфейса SupportContext ему соответствует.
      call(api.POST('/api/v1/support/tickets', { body: { ...input, context: input.context ? { ...input.context } : undefined } })),
  };
}

export type SupportApi = ReturnType<typeof createSupportApi>;

/** Тема обращения: вид обращения и экран («Что-то не работает — Журнал аудита»), не длиннее 200 символов. */
export function supportSubject(topicLabel: string, screenTitle: string): string {
  const subject = screenTitle ? `${topicLabel} — ${screenTitle}` : topicLabel;
  return subject.length > 200 ? `${subject.slice(0, 199)}…` : subject;
}

/** Путь без query и hash: в адресе не должно быть поисковых запросов с ФИО и т. п. */
export function sanitizePath(pathname: string): string {
  return pathname.split(/[?#]/)[0] ?? '/';
}
